import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let CommissionCompetences = {
  BankSlip: { Show: false },
  CreditCard: { Show: false },
  Pix: { Show: false },
  Crypto: { Show: false },
  Ted: { Show: false },
  Sms: { Show: false },
  AntiFraud: { Show: false },
  Anticipation: { Show: false }
};

const request = {
  install(Vue) {
    Vue.prototype.$requestGetCommissionCompetence = function () {
      if (this.$store.getters.CommissionCompetence.length === 0) {
        this.$store.dispatch("GetCommissionCompetence")
        .then(
          response => {
            const fillCommisionCompetences = (paymentMethod, i) => {
              CommissionCompetences[paymentMethod].Show = true;
              CommissionCompetences[paymentMethod].Name = response[i].PaymentMethod.Name;
              CommissionCompetences[paymentMethod].Taxes = response[i].CommissionCompetence;

              CommissionCompetences[paymentMethod].Labels = [];
              let labels = CommissionCompetences[paymentMethod].Labels;
              for (let j = 0; j < response[i].CommissionCompetence.length; j++) {
                const taxAmount = response[i].CommissionCompetence[j].Tax;
                const taxType = response[i].CommissionCompetence[j].TaxType.Id;
                const label = this.$floatToReal(taxAmount, taxType);
                labels.push(label);
              }
            };

            for (let i = 0; i < response.length; i++) {
              switch (response[i].PaymentMethod.Code) {
                case "1":
                  fillCommisionCompetences("BankSlip", i);
                  break;
                case "2":
                  fillCommisionCompetences("CreditCard", i);
                  break;
                case "6":
                  fillCommisionCompetences("Pix", i);
                  break;
                case "15":
                  fillCommisionCompetences("Anticipation", i);
                  break;
                case "14":
                    fillCommisionCompetences("Sms", i);
                    break;
                case "16":
                  fillCommisionCompetences("AntiFraud", i);
                  break;
              };
            };



            this.$store.commit("SET_COMMISSION_COMPETENCE_LIST", CommissionCompetences);
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    Vue.prototype.$floatToReal = (value, taxType) => {
      if (taxType == 2)
        return value.toFixed(2).replace(".", ",") + " R$";
      return value.toFixed(2) + "%";
    }
  }
};

export default request;


// WEBPACK FOOTER //
// ./src/utils/requestGetCommissionCompetence.js